import React, { useState, useEffect } from "react";
import Dashboard from "../../layouts/Dashboard";
import { NavLink as Link } from "react-router-dom";
import $ from "jquery";
import axios from "../../services/axios";
import ReactLoading from "react-loading";
import isConsultant from "../../services/isConsultant";

//datatable
var dt = require("datatables.net");
require("datatables.net-bs4");
$.DataTable = dt;

const CompletedInterviews = (props) => {
  const [interviewList, setInterviewList] = useState([]);
  const [load, setLoad] = useState(false);

  function formatDate(d) {
    let date = new Date(d);
    var dd = date.getDate();
    var mm = date.getMonth() + 1;
    var yyyy = date.getFullYear();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    return (d =
      dd + "/" + mm + "/" + yyyy + " " + hours + ":" + minutes + ":" + seconds);
  }

  useEffect(() => {
    //  setLoad(true)
    axios
      .get("/interviews/clientId/" + localStorage.getItem("user.id"), {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        // console.log("table data", res.data[1].candidate.L4_Status);
        const arrObj = res?.data?.filter((ele) => {
          return (
            ele.candidate.L4_Status === "Selected" ||
            ele.candidate.L4_Status === "Rejected"
          );
        });
        console.log("arr obj", arrObj);
        setInterviewList(arrObj);

        setTimeout(() => {
          $("#table-datatable").DataTable({
            // order: [[3, "desc"]],
            // columnDefs: [{ targets: 3, type: "date" }],
            stateSave: true,
            bDestroy: true,
            responsive: true,
          });
        }, 100);
        // setLoad(false)
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const dateConverter = (d) => {
    const date = d.split("T");
    let p = date[0].split(/\D/g);
    let t = date[1].split(".");
    return [p[2], p[1], p[0]].join("-") + " " + t[0];
  };
  return (
    <div>
    {!isConsultant() && <div>
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <Dashboard>
        <span className="navbar-brand mb-3">Completed Interviews</span>
        <div className="table-responsive card p-3 shadow-sm">
          {/* <table className="table bg-white">
            <thead className="table-head">
              <tr>
                <td className="table-column-head">Name</td>
                <td className="table-column-head">Interview Date & Time</td>
                <td className="table-column-head">Mode of Interview</td>
                <td className="table-column-head">Applied For</td>
                <td className="table-column-head">Interview type</td>
                <td className="table-column-head">Status</td>
                <td className="table-column-head">Action</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>John</td>
                <td>08-07-2021 12:01 PM</td>
                <td>Telephonic</td>
                <td>Support Executive</td>
                <td>P1</td>
                <td>Rejected</td>
                <td>
                  <Link to="./upcominginterviewdetail">
                    <button class="btn btn-sm btn-primary btn-table-control mx-1">
                      View
                    </button>
                  </Link>
                </td>
              </tr>
              <tr>
                <td>Jatinder</td>
                <td>28-07-2021 2:01 PM</td>
                <td>In person (Amritsar)</td>
                <td>Web Engineer</td>
                <td>P3</td>
                <td>Selected</td>
                <td>
                  <Link to="./upcominginterviewdetail" >
                    <button class="btn btn-sm btn-primary btn-table-control mx-1">
                      View
                    </button>
                  </Link>
                </td>
              </tr>
            </tbody>
          </table> */}
          <table id="table-datatable" className="table bg-white">
            <thead className="table-head">
              <tr>
                <td className="table-column-head">Name</td>
                <td className="table-column-head">Mobile</td>
                <td className="table-column-head">Interview Date & Time</td>
                <td className="table-column-head">Email</td>
                <td className="table-column-head">Applied For</td>
                <td className="table-column-head">Interview type</td>
                <td className="table-column-head">Action</td>
              </tr>
            </thead>
            <tbody>
              {interviewList?.map((ele, k) => {
                return (
                  <tr key={k}>
                    <td className="p-1">{ele.candidate.name}</td>
                    <td className="p-1">{ele.candidate.mobileNo}</td>
                    <td className="p-1">
                      {formatDate(ele.candidate.L4SchdulingOn)}
                    </td>

                    <td className="p-1">{ele.candidate.email}</td>
                    <td className="p-1">Customer Care Executive</td>
                    <td className="p-1">Client Round</td>
                    <td className="p-1">
                      <Link
                        to={{
                          pathname: "./upcominginterviewdetail",
                          state: {
                            processName:
                              ele.candidate.recommendedProcess[0].name,
                            id: ele.candidate._id,
                            day: "Completed",
                            date: formatDate(ele.candidate.L4SchdulingOn),
                          },
                        }}
                      >
                        <button
                          onClick={() => {
                            localStorage.setItem(
                              "candidate.Id",
                              ele.candidate._id
                            );
                          }}
                          class="btn btn-sm btn-primary btn-table-control mx-1"
                        >
                          View
                        </button>
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </Dashboard>
    </div>}
    </div>
  );
};

export default CompletedInterviews;
